<template>
    <div
        :class="[
          'tab-structure-item',
            {
                'tab-structure-item--active': selected,
            },
        ]"
        @click="emit('click')"
    >
        {{ t(titleKey) }}
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
defineProps<{
    titleKey: string
    selected: boolean
}>()

const emit = defineEmits<{
    (e: 'click'): void
}>()
</script>

<style scoped lang="scss">
.tab-structure-item {
    cursor: pointer;
    padding-bottom: $spacing-2xs;
    color: $pbl-text-muted;
    transition: color 0.15s ease-in-out;
    user-select: none;
    display: flex;
    align-items: center;
    gap: $spacing-3xs;
    font-weight: 500;

    &:hover:not(&--active) {
        color: $pbl-text;
    }

    &--active {
        cursor: default;
        color: $pbl-primary;
        border-bottom: 2px solid $pbl-primary;
    }
}
</style>
